import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  container({ container_id }) {
    return RequesterV1.get(
      `agro_exporter/production/uniq_final_packing_list/new_packages/container/${container_id}`
    );
  },
  createPackages(container_id, packages) {
    return RequesterV1.post(
      `agro_exporter/production/uniq_final_packing_list/new_packages/container/${container_id}/create/`,
      { packages: packages }
    );
  },
  fetchExportProcessCropCategories(agro_exporter_process_id) {
    return RequesterV1.get(
      "agro_exporter/production/uniq_final_packing_list/new_packages/list_exporter_process_crop_categories/" +
        agro_exporter_process_id
    );
  },
  fetchExportProcessCropVarieties(agro_exporter_process_id) {
    return RequesterV1.get(
      "agro_exporter/production/uniq_final_packing_list/new_packages/list_exporter_process_crop_varieties/" +
        agro_exporter_process_id
    );
  },
  fetchExportProcessCropSizes(agro_exporter_process_id) {
    return RequesterV1.get(
      "agro_exporter/production/uniq_final_packing_list/new_packages/list_exporter_process_crop_sizes/" +
        agro_exporter_process_id
    );
  },
  fetchExportProcessBrands(agro_exporter_process_id, container_id) {
    return RequesterV1.get(
      `agro_exporter/production/uniq_final_packing_list/new_packages/list_exporter_process_brands/${agro_exporter_process_id}/${container_id}`
    );
  },
  fetchExportProcessCropPackages(agro_exporter_process_id) {
    return RequesterV1.get(
      "agro_exporter/production/uniq_final_packing_list/show_container/list_exporter_process_crop_packages/" +
        agro_exporter_process_id
    );
  },
  fetchPackageGroups(container_id) {
    return RequesterV1.get(
      "agro_exporter/production/uniq_final_packing_list/new_packages/list_package_groups/" +
        container_id
    );
  },
  fetchProducersOrganizations(agro_exporter_process_id) {
    return RequesterV1.get(
      "agro_exporter/production/uniq_final_packing_list/new_packages/fetch_producers_organizations/" +
        agro_exporter_process_id
    );
  }
};
